<template>
    <div class="alert" :class="alertType">
        <i :class="icon" />
        <div>
            <strong>{{title}} — </strong>{{message}}
        </div>
    </div>
</template>

<script>
export default {
  props: ['message', 'title', 'type'],
  computed: {
    alertType () {
      return `alert-${this.type}`
    },
    icon () {
      switch (this.type) {
        case 'pending':
          return 'icon-eyes'
        case 'published':
          return 'icon-rocket'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 40px;
  height: 40px;
}
.alert {
    border: 2px solid;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: .25rem;
    background: #fff;
    display: flex;
    align-items: center;

    img {
        height: 2.5rem;
        margin-right: 1rem;
    }

    p {
      margin-top: .5rem;
    }
}

.alert-published {
    border-color: #7fdeb4;
}

.alert-pending {
    border-color: #fedd97
}
</style>



// WEBPACK FOOTER //
// src/components/general/alert.vue